import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import {
  forgotPassword,
  loginUser,
  logoutUser,
  registerUser,
  verifyOtp,
  resetPassword,
  signupOtp,
  resendOtp,
} from '../actions/auth';
import { toast } from 'react-toastify';
import { getFromStorage, setToStorage } from 'utils/storage';
import {
  changeUserPassword,
  deleteAccount,
  getProfileDetails,
  profileUpdate,
  updateUserStatus,
} from '../actions/user';

const initialState = {
  userLoading: false,
  token: getFromStorage('accessToken'),
  currentUser: {
    user_id: getFromStorage('user_id') || null,
  },
  emailTopics: null,
};

const userSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.fulfilled, (state, action) => {
        if (action.payload?.success && action.payload?.data?.refreshToken) {
          const token = action.payload.data?.accessToken;
          const refreshToken = action.payload.data?.refreshToken;
          const userData = action.payload.data;
          state.token = token;
          state.currentUser = action.payload.data;
          setToStorage('accessToken', token);
          setToStorage('refreshToken', refreshToken);
        }
      })
      .addCase(profileUpdate.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.userLoading = false;
          state.currentUser = action.payload.user ;
        }
      })
      .addCase(getProfileDetails.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.currentUser = action.payload.data;
        }
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.currentUser = action.payload.data;
        }
      })

      .addCase(verifyOtp.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.currentUser = action.payload.data;
        }
      })
      .addCase(signupOtp.fulfilled, (state, action) => {
        if (action.payload?.success && action.payload?.data?.refreshToken) {
          const token = action.payload.data?.accessToken;
          const refreshToken = action.payload.data?.refreshToken;
          state.token = token;
          state.userLoading = false;
          state.currentUser = action.payload.data;
          setToStorage('accessToken', token);
          setToStorage('refreshToken', refreshToken);
        }
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.currentUser = action.payload.data;
        }
      })

      .addCase(registerUser.fulfilled, (state, action) => {
        if (action.payload?.success && action.payload?.data?.refreshToken) {
          // const token = action.payload.data?.refreshToken;
          // state.token = token;
          state.userLoading = false;
          state.currentUser = action.payload.data;
        }
      })
      .addCase(resendOtp.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.userLoading = false;
        }
      })
      .addCase(updateUserStatus.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.userLoading = false;
          // Update user status if the response contains user data
          if (action.payload?.data) {
            state.currentUser = { ...state.currentUser, ...action.payload.data };
          }
          // Toast is handled manually in component to ensure visibility before page reload
        }
      })
      .addCase(deleteAccount.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.userLoading = false;
          // Toast is handled manually in component to ensure visibility before page reload
        }
      })
      .addCase(updateUserStatus.pending, (state, action) => {
        state.userLoading = true;
      })
      .addCase(deleteAccount.pending, (state, action) => {
        state.userLoading = true;
      })
      .addCase(updateUserStatus.rejected, (state, action) => {
        state.userLoading = false;
        // Error toast is handled manually in component
      })
      .addCase(deleteAccount.rejected, (state, action) => {
        state.userLoading = false;
        // Error toast is handled manually in component
      })

      .addMatcher(
        isAnyOf(
          loginUser.pending,
          resendOtp.pending,
          resetPassword.pending,
          verifyOtp.pending,
          signupOtp.pending,
          registerUser.pending,
          forgotPassword.pending,
          logoutUser.pending
        ),
        (state, action) => {
          state.userLoading = true;
        }
      )
      .addMatcher(
        isAnyOf(profileUpdate.pending, changeUserPassword.pending),
        (state, action) => {
          state.userLoading = false;
        }
      )
      .addMatcher(
        isAnyOf(
          changeUserPassword.fulfilled,
          resetPassword.fulfilled,
          resendOtp.fulfilled,
          signupOtp.fulfilled,
          verifyOtp.fulfilled,
          forgotPassword.fulfilled,
          registerUser.fulfilled,
          profileUpdate.fulfilled,
          logoutUser.fulfilled
        ),
        (state, action) => {
          state.userLoading = false;
          const successMessage = action.payload?.message;
          if (typeof successMessage === 'string') {
            // toast.success(successMessage);
          }
        }
      )
      .addMatcher(
        isAnyOf(
          loginUser.rejected,
          verifyOtp.rejected,
          resendOtp.rejected,
          signupOtp.rejected,
          resetPassword.rejected,
          registerUser.rejected,
          forgotPassword.rejected,
          profileUpdate.rejected,
          changeUserPassword.rejected,
          logoutUser.rejected
        ),
        (state, action) => {
          if (state.userLoading) {
            state.userLoading = false;
            const errorMessage = action.payload;
            if (typeof errorMessage === 'string') {
              toast.error(errorMessage);
            }
          }
        }
      );
  },
});

export default userSlice.reducer;
export const { setToken } = userSlice.actions;
